import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { forwardRef } from 'react';
import { BiContainer, Tooltip, IconButton, DropdownMenu, DropdownMenuItem } from 'seagull';
import { EditLine, MoreVertical, TrashLine, TrashLiner24, WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import { useServiceAdvancedSettingsAdditionalSection } from '~/components/ServiceAdvancedSettings';
import ServicePanel, { getTestId } from '~/components/ServicePanel/ServicePanel';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import styles from './DraftServiceInstance.module.scss';
const DraftServiceInstance = /*#__PURE__*/ forwardRef(function DraftServiceInstance(props, ref) {
    const { service, idx, canMoveDown, canMoveUp, isInvalid, isReadOnly = false, advancedSettingsProps, showErrors, serviceDetailsProps, onEditServiceNameAndDescription, onEditService, onRemoveService, onMoveDown, onMoveUp } = props;
    const serviceAdvancedSettingsAdditionalSection = useServiceAdvancedSettingsAdditionalSection(_object_spread_props(_object_spread({}, advancedSettingsProps), {
        service,
        isReadOnly,
        testId: "draft-service-".concat(idx)
    }));
    const { INLINE_EDIT_MENU = false } = useFeatureFlags();
    return /*#__PURE__*/ _jsx(BiContainer, {
        name: "service_card",
        data: {
            serviceId: service.id
        },
        children: /*#__PURE__*/ _createElement(ServicePanel, _object_spread_props(_object_spread({
            serviceOrigin: "draft",
            isVendor: true,
            showBadges: true,
            billingInitiationProps: {
                isExistingService: false
            },
            ignoreAmendments: true,
            context: "draft"
        }, serviceDetailsProps), {
            key: service.id || idx,
            ref: ref,
            service: service,
            idx: idx,
            error: showErrors && isInvalid,
            isReadOnly: isReadOnly,
            additionalSections: [
                serviceAdvancedSettingsAdditionalSection
            ],
            onEditServiceNameAndDescription: onEditServiceNameAndDescription,
            menu: !isReadOnly && /*#__PURE__*/ _jsxs("div", {
                className: styles.inlineMenu,
                children: [
                    !INLINE_EDIT_MENU && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Tooltip, {
                                title: "Edit service for this proposal",
                                children: /*#__PURE__*/ _jsx(IconButton, {
                                    onClick: ()=>onEditService(service),
                                    testId: "".concat(getTestId(idx), "inline-menu-edit"),
                                    children: /*#__PURE__*/ _jsx(EditLine, {})
                                })
                            }),
                            /*#__PURE__*/ _jsx(Tooltip, {
                                title: "Delete service for this proposal",
                                children: /*#__PURE__*/ _jsx(IconButton, {
                                    onClick: ()=>onRemoveService(service.id),
                                    testId: "".concat(getTestId(idx), "inline-menu-delete"),
                                    children: /*#__PURE__*/ _jsx(TrashLine, {})
                                })
                            })
                        ]
                    }),
                    (canMoveDown || canMoveUp || INLINE_EDIT_MENU) && /*#__PURE__*/ _jsxs(DropdownMenu, {
                        target: /*#__PURE__*/ _jsx(IconButton, {
                            className: INLINE_EDIT_MENU ? styles.ellipsisMenu : undefined,
                            testId: "".concat(getTestId(idx), "ellipsis-menu"),
                            children: /*#__PURE__*/ _jsx(MoreVertical, {})
                        }),
                        children: [
                            (canMoveDown || canMoveUp) && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                        iconStart: /*#__PURE__*/ _jsx(WideArrowUpward, {}),
                                        testId: "".concat(getTestId(idx), "move-up"),
                                        disabled: !canMoveUp,
                                        onClick: onMoveUp,
                                        children: "Move Up"
                                    }),
                                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                        iconStart: /*#__PURE__*/ _jsx(WideArrowDownward, {}),
                                        testId: "".concat(getTestId(idx), "move-down"),
                                        disabled: !canMoveDown,
                                        onClick: onMoveDown,
                                        children: "Move Down"
                                    })
                                ]
                            }),
                            INLINE_EDIT_MENU && /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                iconStart: /*#__PURE__*/ _jsx(TrashLiner24, {}),
                                testId: "".concat(getTestId(idx), "remove-service"),
                                disabled: isReadOnly,
                                onClick: ()=>onRemoveService(service.id),
                                skin: "error",
                                children: "Remove"
                            })
                        ]
                    })
                ]
            })
        }))
    });
});
export default DraftServiceInstance;
